<template>
    <div class="group flex flex-row-reverse items-center gap-6 py-10 lg:flex-row">
        <div class="rounded-card-sm h-24 w-24 shrink-0 animate-pulse overflow-hidden bg-gray-200 lg:h-80 lg:w-80" />

        <div class="flex flex-1 flex-col space-y-2 lg:px-10 lg:py-12">
            <div class="flex flex-wrap items-center gap-x-2">
                <small
                    class="text-neutral-extra-subtle h-2 max-w-[100px] flex-1 animate-pulse rounded bg-gray-200 text-sm"
                />
                <small
                    class="text-neutral-extra-subtle h-2 max-w-[100px] flex-1 animate-pulse rounded bg-gray-200 text-sm"
                />
                <small
                    class="text-neutral-extra-subtle h-2 max-w-[100px] flex-1 animate-pulse rounded bg-gray-200 text-sm"
                />
            </div>
            <h2 class="h-8 animate-pulse rounded bg-gray-200" />
            <p class="text-neutral-base line-clamp-2 h-4 animate-pulse rounded bg-gray-200 text-lg" />
            <p class="text-neutral-base line-clamp-2 h-4 animate-pulse rounded bg-gray-200 text-lg" />
            <small class="text-neutral-extra-subtle h-3 max-w-[150px] animate-pulse rounded bg-gray-200 text-sm" />
        </div>
    </div>
</template>

<script setup></script>
